import React, { useEffect, useMemo, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { ISizeObj, NotificationPayload } from 'customTypes';
import { toast, ToastContainer } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import GlobalStyle from './assets/styles/GlobalStyle';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import SiteDashboard from './pages/SiteDashboard';
import NotFound from './pages/NotFound';

import Master1 from './pages/master/Master1';
import Master2 from './pages/master/Master2';
import Master3 from './pages/master/Master3';
import Master4 from './pages/master/Master4';
import Master6 from './pages/master/Master6';
import Master7 from './pages/master/Master7';
import Mmenu1 from './pages/m_menu/M_menu1';
import Mmenu2 from './pages/m_menu/M_menu2';
import Mcommon1 from './pages/m_common/M_common1';
import Mcommon2 from './pages/m_common/M_common2';
import Mcommon3 from './pages/m_common/M_common3';
import Mcommon4 from './pages/m_common/M_common4';
import Mcommon5 from './pages/m_common/M_common5';
import Mcommon6 from './pages/m_common/M_common6';

import Hinfo1 from './pages/h_info/H_info1';
import Huser1 from './pages/h_user/H_user1';
import Hcctv1 from './pages/h_cctv/H_cctv1';
import Hcctv2 from './pages/h_cctv/H_cctv2';
import Hcommon1 from './pages/h_common/H_common1';
import Hsinfo1 from './pages/h_sinfo/H_sinfo1';
import Hsinfo2 from './pages/h_sinfo/H_sinfo2';
import Hcommon2 from './pages/h_common/H_common2';
import Hcommon3 from './pages/h_common/H_common3';
import Hcommon4 from './pages/h_common/H_common4';

import Scctv1 from './pages/s_cctv/S_cctv1';
import SMSetting1 from './pages/sm_setting/SM_setting1';
import SMSetting2 from './pages/sm_setting/SM_setting2';
import SMSetting3 from './pages/sm_setting/SM_setting3';
import SMSetting4 from './pages/sm_setting/SM_setting4';
import SMSetting5 from './pages/sm_setting/SM_setting5';
import SMSetting6 from './pages/sm_setting/SM_setting6';
import SMSetting7 from './pages/sm_setting/SM_setting7';
import SMSetting9 from './pages/sm_setting/SM_setting9';
import SMSetting10 from './pages/sm_setting/SM_setting10';
import SMSetting11 from './pages/sm_setting/SM_setting11';

import Suser1 from './pages/s_user/S_user1';
import Sinfo1 from './pages/s_info/S_info1';
import Sworker1 from './pages/s_worker/S_worker1';
import Sworker2 from './pages/s_worker/S_worker2';
import Sworker4 from './pages/s_worker/S_worker4';
import Sworker5 from './pages/s_worker/S_worker5';
import Sworker11 from './pages/s_worker/S_worker11';
import Sworker10 from './pages/s_worker/S_worker10';
import Sworker9 from './pages/s_worker/S_worker9';
import Sworker8 from './pages/s_worker/S_worker8';
import Sworker7 from './pages/s_worker/S_worker7';
import Sworker6 from './pages/s_worker/S_worker6';
import Sattend1 from './pages/s_attend/S_attend1';
import Sattend8 from './pages/s_attend/S_attend8';
import Sattend7 from './pages/s_attend/S_attend7';
import Sattend6 from './pages/s_attend/S_attend6';
import Sattend5 from './pages/s_attend/S_attend5';
import Sattend4 from './pages/s_attend/S_attend4';
import Sattend3 from './pages/s_attend/S_attend3';
import Sattend2 from './pages/s_attend/S_attend2';
import Ssafe1 from './pages/s_safe/S_safe1';
import Ssafe2 from './pages/s_safe/S_safe2';
// import Ssafe3 from './pages/s_safe/S_safe3';
import Ssafe4 from './pages/s_safe/S_safe4';
import Ssafe5 from './pages/s_safe/S_safe5';
import Ssafe6 from './pages/s_safe/S_safe6';
import Ssafe7 from './pages/s_safe/S_safe7';
import Ssensor1 from './pages/s_sensor/S_sensor1';
import Ssensor2 from './pages/s_sensor/S_sensor2';
import Ssensor3 from './pages/s_sensor/S_sensor3';
import Ssensor4 from './pages/s_sensor/S_sensor4';
import Ssensor5 from './pages/s_sensor/S_sensor5';
import Ssensor6 from './pages/s_sensor/S_sensor6';
import Ssensor7 from './pages/s_sensor/S_sensor7';
import Ssensor8 from './pages/s_sensor/S_sensor8';
import Ssensor9 from './pages/s_sensor/S_sensor9';
import Sbroadcast1 from './pages/s_broadcast/S_broadcast1';
import LogReport from './pages/LogReport';
import { ThemeProvider } from 'styled-components';
import { light, dark } from './assets/styles/theme';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { bScreenMode, IUser, IPageInfo, pageInfoState, themeState, tunnelReverseState, userState } from './atoms';
import * as cctv from './utils/cctv';
import { useTranslation } from 'react-i18next';
import Stunnel1 from './pages/s_tunnel/S_tunnel1';
import { Mqtt } from './utils/mqttClass';
import AlertModal from './components/Modal/AlertModal';
import useTimer from './utils/useTimer';
import { fetchTunnelReversed } from './services/Tunnel';
import RealtimeCCTV from './pages/s_cctv/S_cctv1/RealtimeCCTV';
import PlayCCTV from './pages/s_cctv/S_cctv1/PlayCCTV';
import DownloadCctv from './pages/s_cctv/S_cctv1/PlayCCTV/DownloadCctv';
import Video from './components/Video';
import SMSetting12 from './pages/sm_setting/SM_setting12';
import Ssafeedu1 from './pages/s_safeedu/S_safeedu1';
import Ssafeedu2 from './pages/s_safeedu/S_safeedu2';
import NotiModal from './components/Modal/NotiModal';
import CUser1 from './pages/c_user/C_user1';
import CSetting1 from './pages/c_setting/C_setting1';
import CSetting2 from './pages/c_setting/C_setting2';
import CSetting3 from './pages/c_setting/C_setting3';
import CSetting4 from './pages/c_setting/C_setting4';
import CSetting5 from './pages/c_setting/C_setting5';
import CSetting6 from './pages/c_setting/C_setting6';
import CSetting7 from './pages/c_setting/C_setting7';
import CSetting11 from './pages/c_setting/C_setting11';
import CWork1 from './pages/c_work/C_work1';
import CWork2 from './pages/c_work/C_work2';
import CWork3 from './pages/c_work/C_work3';
import CWork4 from './pages/c_work/C_work4';
import CWork5 from './pages/c_work/C_work5';
import CWork6 from './pages/c_work/C_work6';
import CWork7 from './pages/c_work/C_work7';
import CCompany1 from './pages/c_company/C_company1';
import CCompany2 from './pages/c_company/C_company2';
import CCompany3 from './pages/c_company/C_company3';
import GlobalTheme from './assets/styles/GlobalTheme';
import Cattend1 from './pages/c_attend/C_attend1';
import Cattend2 from './pages/c_attend/C_attend2';
import Cattend3 from './pages/c_attend/C_attend3';
import Cattend4 from './pages/c_attend/C_attend4';
import Cattend5 from './pages/c_attend/C_attend5';
import CBoard from './pages/c_board/C_board';

import ServiceReportPage from './pages/ServiceReportPage';
import { playAlertSound } from './utils/playAlertSound';
import { handleFlutterLogoutAndRemoveCookies, setupFlutterFormSubmitHandler } from './utils/flutterBridge';
import Sattend9 from './pages/s_attend/S_attend9';
import SMSetting13 from './pages/sm_setting/SM_setting13';
import Ssensor10 from './pages/s_sensor/S_sensor10';
import Ssensor11 from './pages/s_sensor/S_sensor11';
import Master8 from './pages/master/Master8';
import Hvisitor1 from './pages/h_visitor/H_visitor1';
import Hvisitor2 from './pages/h_visitor/H_visitor2';
import AppNotificationModal from './components/Modal/AppNotificationModal';
import IosA2hsModal from './components/Modal/IosA2hsModal';
import { isMobile } from './utils/checkMobile';

declare global {
  interface Window {
    setFlutterUserInfo: (userInfoJson: string, menuListJson: string) => void;
    FlutterWebView: {
      callHandler: (name: string, ...args: any[]) => void;
      postMessage: (message: string) => void;
    };
    FilePicker?: {
      postMessage: (message: string) => void;
    };
    VideoFilePicker?: {
      postMessage: (message: string) => void;
    };
    FileDownloader?: {
      postMessage: (message: string) => void;
    };
    MapViewer?: {
      postMessage: (message: string) => void;
    };
    ViewportSetter?: {
      postMessage: (message: string) => void;
    };
    FormSubmit?: {
      postMessage: (message: string) => void;
    };
    AttachmentBridge?: {
      postMessage: (message: string) => void;
    };
    TokenRefresh?: {
      postMessage: (message: string) => void;
    };
    downloadFile?: (fileUrl: string, filename: string) => Promise<void>;
    handleFileSelected?: (file: { name: string; path: string; size: number; extension: string }) => Promise<void>;
    handleFileError?: (error: string) => void;
    handleVideoSelected?: (file: { name: string; path: string; size: number; extension: string; mimeType: string; base64: string }) => Promise<void>;
    handleVideoError?: (error: string) => void;
    handleAddressSelected: (data: any) => void;
    handlePushNotification?: (payload: NotificationPayload) => void;
    handleFormSubmitResult?: (payload: any) => void;
  }
}

// 기본 함수 정의
window.setFlutterUserInfo = () => {};

const App = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const token = Cookies.get('prosafeToken');
  const refreshToken = Cookies.get('refreshToken');
  const [userInfo, setUserInfo] = useRecoilState<IUser>(userState);
  const setPageInfo = useSetRecoilState<IPageInfo>(pageInfoState);
  const location = useLocation();
  const [login, setLogin] = useState(token !== undefined);
  const theme = useRecoilValue(themeState);
  const colorMode = useRecoilValue(bScreenMode);
  const resetUserInfo = useResetRecoilState(userState);
  const [openModal, setOpenModal] = useState<any>({ status: false, type: 'noti' });
  const [openAiModal, setOpenAiModal] = useState<any>({ status: false, type: 'aiAlertModal' });
  const [mqtt, setMqtt] = useState<Mqtt>();
  const ALERT_DURATION = 60; // 알럿창 유지 시간(초)
  const notiConfirmDate = window.localStorage.getItem('notiConfirmDate');
  const [appNotificationModal, setAppNotificationModal] = useState<{ isOpen: boolean; data: any | null }>({ isOpen: false, data: null });
  const [deviceType, setDeviceType] = useState<'Web' | 'Android' | 'iOS'>('Web');
  const mobile = useMemo(() => isMobile(), []);

  const [mode, setMode] = useState('COL'); // 가로, 세로모드
  const [size, setSize] = useState<ISizeObj>({
    innerSize: { W: 0, H: 0 },
    clientSize: { W: 0, H: 0 },
  });

  // Flutter FormSubmit 콜백 핸들러 등록
  // Flutter에서 폼 업로드/일정 추가·수정 등의 요청을 처리한 후,
  // window.handleFormSubmitResult로 성공/실패 결과를 전달하면
  // 이 핸들러가 요청 ID를 기반으로 대기 중인 Promise를 resolve/reject하여
  // 웹에서도 Flutter 업로드 완료를 감지하고 refetch 등의 후처리를 수행할 수 있게 함
  useEffect(() => {
    setupFlutterFormSubmitHandler();
  }, []);

  const DestroySdk = (fn: (e: any) => void) => {
    const cb = React.useRef(fn);

    useEffect(() => {
      const onUnload = cb.current;
      window.addEventListener('beforeunload', onUnload);
      return () => {
        window.removeEventListener('beforeunload', onUnload);
      };
    }, []);
  };
  DestroySdk((e: any) => {
    // e.preventDefault();
    cctv.destroy();
  });

  /**
   * 상황판 화면 확대 조정
   * 스마트TV 환경에서 화면이 너무 크게 표시되는 것을 방지
   */
  useEffect(() => {
    // 상황판 페이지이고 스마트TV 환경인 경우에만 실행
    // const isSmartTV =
    //   /Tizen|WebOS|webOS|Android TV|SmartTV|NetCast|HbbTV|Viera|AppleTV/i.test(navigator.userAgent) || (navigator.userAgent.includes('Android') && !navigator.userAgent.includes('Mobile'));

    if (location.pathname === '/board') {
      if (window?.devicePixelRatio > 1) {
        const zoom = Math.max(0.5, Math.min(1.0, 1 / window.devicePixelRatio));

        (document.body.style as any).zoom = String(zoom);
      } else {
        (document.body.style as any).zoom = '1';
      }

      window.document.documentElement.classList.add('root-dashboard-monitor');
    }
  }, [window.devicePixelRatio]);

  useEffect(() => {
    if (window.FlutterWebView) {
      // Flutter에서 호출하는 함수 재정의
      window.setFlutterUserInfo = (userInfoJson: string, menuListJson: string) => {
        try {
          const parsedUserInfo = JSON.parse(userInfoJson);
          const menuList = JSON.parse(menuListJson);

          setUserInfo((prev: any) => ({
            ...prev,
            ...parsedUserInfo,
            userMenuList: menuList,
          }));

          setPageInfo({
            header: { mtName: '대시보드', mdName: '' },
            mtCd: '',
            mdCd: '',
            mrCd: '',
            defaultMrCd: '',
            tabList: [],
          });

          console.log('[Web] Flutter로부터 상태 수신 및 반영 완료:', JSON.stringify(parsedUserInfo, null, 2));
        } catch (e) {
          console.error('[Web] 상태 파싱 실패:', e);
        }
      };

      // 푸시 알림 처리 함수
      window.handlePushNotification = (payload: any) => {
        try {
          console.log('[Web] Flutter로부터 푸시 알림 수신:', JSON.stringify(payload, null, 2));
          const payloadData = typeof payload.data === 'string' ? JSON.parse(payload.data) : payload.data;
          // 알림 모달 상태 업데이트
          setAppNotificationModal({
            isOpen: true,
            data: payloadData,
          });
          // 캘린더 데이터 갱신
          queryClient.invalidateQueries({ queryKey: ['schedules'] });
        } catch (e) {
          console.error('[Web] 푸시 알림 처리 실패:', e);
        }
      };
    }
  }, []);

  const setIsReversed = useSetRecoilState(tunnelReverseState);

  useEffect(() => {
    if (notiConfirmDate) {
      if (new Date(notiConfirmDate).getDate() !== new Date().getDate()) {
        setOpenModal({ status: true, type: 'noti' });
      }
    } else {
      setOpenModal({ status: true, type: 'noti' });
    }
  }, [notiConfirmDate]);

  // 우클릭 방지 처리 ( 모바일 환경에서는 우클릭 방지 처리 안함 )
  useEffect(() => {
    if (!mobile) {
      document.oncontextmenu = () => false;
    } else {
      document.oncontextmenu = () => true;
    }
  }, [mobile]);

  useEffect(() => {
    /**
     * 수정자 : 한영광
     * 수정일자 : 2023.11.20
     * 수정내용 : 상환판용 계정은 중복 로그인 가능하게 처리
     *           (test 계정은 임시로 중복로그인 가능하게 처리함 출시 이후 삭제할 예정)
     */
    if (login) {
      if (mqtt && mqtt.connected()) {
        mqtt.end();
      }
      setMqtt(new Mqtt());
    }
  }, [userInfo.userId, userInfo.hCd, userInfo.sCd, login]);

  useEffect(() => {
    if (navigator.userAgent.indexOf('Android') !== -1) {
      setDeviceType('Android');
    } else if (navigator.userAgent.indexOf('iPhone') !== -1) {
      setDeviceType('iOS');
    } else {
      setDeviceType('Web');
    }
  }, []);

  useEffect(() => {
    if (mqtt) {
      const alertDataClosure = alertDataFunction();
      const aiAlertDataClosure = aiAlertDataFunction();

      let duplicateUserToken = '';
      mqtt.on('connect', () => {
        // console.log('Connected to MQTT broker mqttClient');
        if (userInfo.userId && userInfo.userId !== 'siteDashboardViewer' && userInfo.userId !== 'test' && location.pathname !== '/download_cctv') {
          mqtt.publish(`${userInfo.userId}_${deviceType}`, `signin/${refreshToken}`);
          mqtt.subscribe(`${userInfo.userId}_${deviceType}`);
        }
        if (userInfo.sCd !== '00000' || userInfo.hCd?.substring(0, 1)?.toLowerCase() === 'c') {
          mqtt.subscribe(`${userInfo.hCd}${userInfo.sCd}/#`);
        }
      });
      mqtt.on('message', (topic: any, message: any) => {
        const [key, userToken] = message.toString().split('/');
        if (topic === `${userInfo.userId}_${deviceType}` && userToken !== duplicateUserToken) {
          if (key === 'signin' && userToken !== refreshToken) {
            mqtt.publish(`${userInfo.userId}_${deviceType}`, `not empty/${refreshToken}`);
          }

          if (key === 'not empty' && userToken !== refreshToken) {
            // 웹에서만 알럿 노출
            if (!window.FlutterWebView) alert(`${t('먼저 로그인된 기기에서 로그아웃됩니다')}`);

            mqtt.publish(`${userInfo.userId}_${deviceType}`, `logout/${refreshToken}`);
          }

          if (key === 'logout' && userToken !== refreshToken) {
            mqtt.end();
            setLogin(false);
            Cookies.remove('prosafeToken');
            Cookies.remove('refreshToken');
            alert(`${t('다른 기기에서 로그인')}`);
            handleFlutterLogoutAndRemoveCookies();
          }

          duplicateUserToken = userToken;
        } else if (topic.split('/')[1] === 'board' && window.location.pathname === '/board') {
          mqtt.end();
          window.location.reload();
        } else if (topic.split('/')[1] === 'serverS') {
          const newAlertData = alertDataClosure.addAlertData(JSON.parse(message.toString()).data);
          if (window.location.pathname !== '/board') {
            setOpenModal({ status: true, type: 'alertModal', data: newAlertData, initAlertData: alertDataClosure.initAlertData });
          }
        } else if (topic.split('/')[1] === 'serverBC') {
          const newAlertData = alertDataClosure.addAlertData(JSON.parse(message.toString()).data);
          if (window.location.pathname !== '/board') {
            setOpenModal({ status: true, type: 'alertModal', data: newAlertData, initAlertData: alertDataClosure.initAlertData });
          }
        } else if (topic.split('/')[1] === 'serverAI') {
          const newAlertData = aiAlertDataClosure.addAlertData(JSON.parse(message.toString()).data);
          if (window.location.pathname !== '/board') {
            playAlertSound();
            setOpenAiModal({ status: true, type: 'aiAlertModal', data: newAlertData, initAlertData: aiAlertDataClosure.initAlertData });
          }
        }
      });

      mqtt.on('error', (error: any) => {
        console.error('MQTT mqttClient error:', error);
      });
      mqtt.on('disconnect', (e: any) => {
        console.log('disconnect', e);
      });
    }
  }, [mqtt]);

  useEffect(() => {
    if (token !== undefined) setLogin(true);
    else setLogin(false);
  }, [token]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('color-mode', theme);
  }, [theme]);

  useEffect(() => {
    // 상황판일 경우 테마 설정
    if (location.pathname === '/board') {
      document.documentElement.setAttribute('data-theme', colorMode === '1' ? 'light' : 'dark');
    }
  }, [colorMode]);

  // 터널 역방향/정방향 전역변수 설정
  useEffect(() => {
    if (login) {
      if (userInfo.sCd && userInfo.sCd !== '00000') fetchTunnelReveredState();
    }
  }, [login, userInfo.sCd]);

  useEffect(() => {
    sizeCheck();

    // 모바일에서는 resize 이벤트 리스너 등록하지 않음
    if (mobile) {
      return undefined;
    }
    window.addEventListener('resize', sizeCheck);
    // 구형 iOS에서는 window.screen.orientation이 지원되지 않음 (iOS 13+)
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener('change', sizeCheck);
    }
    return () => {
      window.removeEventListener('resize', sizeCheck);
      if (window.screen?.orientation) {
        window.screen.orientation.removeEventListener('change', sizeCheck);
      }
    };
  }, [window.innerWidth, userInfo.userId]);

  const sizeCheck = () => {
    if (window.screen.availWidth < window.screen.availHeight) setMode('ROW');
    setSize({
      innerSize: { W: window.innerWidth, H: window.innerHeight },
      clientSize: { W: window.screen.availWidth, H: window.screen.availHeight },
    });
    if (cctv.getPluginOBJECT()?.oPlugin && location.pathname === '/') {
      cctv.destroy();
    }
  };

  const alertDataFunction = () => {
    let alertData: any[] = [];
    const addAlertData = (data: any) => {
      alertData.push(data);
      if (useTimer.getCount() > 0) {
        useTimer.setCount(ALERT_DURATION);
      } else {
        useTimer.startCounter(ALERT_DURATION, initAlertData, setOpenModal);
      }
      return alertData.sort((a, b) => b.time - a.time);
    };
    const initAlertData = () => {
      alertData = [];
    };
    return {
      addAlertData,
      initAlertData,
    };
  };

  const aiAlertDataFunction = () => {
    let alertData: any[] = [];
    const addAlertData = (data: any) => {
      alertData.push(data);
      return alertData.sort((a, b) => b.time - a.time);
    };
    const initAlertData = () => {
      alertData = [];
    };
    return {
      addAlertData,
      initAlertData,
    };
  };

  // // 상황판 자동 새로고침 - 수정 필요
  // useEffect(() => {
  //   // 상황판에서만 자동 새로고침 = 여기서 쿼리만 ?cCd 인것만 새로고침 하도록 수정
  //   if (location.pathname === '/board') {
  //     const checkRefresh = setInterval(() => {
  //       const now = new Date();
  //       const currentHour = now.getHours();
  //       const currentMinute = now.getMinutes();

  //       // 1. 목표 시간 확인 ( 매일 새벽 3:00 )
  //       if (currentHour === 15 && currentMinute === 51) {
  //         const today = now.toISOString().split('T')[0]; // "2025-12-18" 형식
  //         const lastReloadDate = localStorage.getItem('last_reload_date');

  //         // 2. 오늘 이미 새로고침을 했는지 체크 (무한 루프 방지)
  //         if (lastReloadDate !== today) {
  //           // 오늘 날짜를 저장하여 중복 새로고침 방지
  //           localStorage.setItem('last_reload_date', today);

  //           // 3. 강력 새로고침 수행 (타임스탬프를 쿼리스트링에 추가)
  //           // TV 환경에서 캐시를 무시하고 서버에서 새 파일을 받아오게 함
  //           const searchQuery = window.location.search.replace(/&t=\d+/, ''); // '&t=0000000000000' 이 있으면 제거
  //           const aa = window.location.pathname; // '/board?cCd=C001&t=0000000000000' 이 있을 때 ?cCd=C001만 가져오기
  //           const refreshUrl = `${window.location.origin}${window.location.pathname}${searchQuery}&t=${now.getTime()}`;
  //           window.location.href = refreshUrl;
  //         }
  //         const refreshUrl = `${window.location.origin}${window.location.pathname}${window.location.search}&t=${now.getTime()}`;
  //         window.location.href = refreshUrl;
  //       }
  //     // }, 60000 * 60); // 1시간마다 체크

  //     return () => clearInterval(checkRefresh);
  //   }
  //   return () => {};
  // }, []);

  useEffect(() => {
    // 상황판에서만 자동 새로고침
    if (location.pathname === '/board') {
      // 새벽 3시 새로고침 처리
      const checkRefresh = setInterval(() => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        // 3시 00분부터 3시 10분 사이에 타이머가 걸리면 무조건 새로고침 실행
        if (currentHour === 3 && currentMinute >= 0 && currentMinute <= 10) {
          window.location.reload();
        }
      }, 60000 * 10); // 10분마다 체크

      return () => clearInterval(checkRefresh);
    }

    return () => {};
  }, []);

  useEffect(() => {
    setScreenSize();
  });

  // 터널 정방향/역방향 설정 함수
  const fetchTunnelReveredState = async () => {
    const isTunnelReversed = await fetchTunnelReversed(userInfo);
    isTunnelReversed !== null && setIsReversed(isTunnelReversed);
  };

  const checkScreenMode = () => {
    if (location.pathname === '/board') {
      return colorMode === '1' ? light : dark;
    }
    return theme === 'light' ? light : dark;
  };

  function setScreenSize() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  return (
    <ThemeProvider theme={location.pathname !== undefined && checkScreenMode}>
      <GlobalTheme />
      <GlobalStyle />
      <ToastContainer
        style={{ zIndex: 999999 }}
        position='top-center'
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
      <Routes>
        {login ? (
          <>
            <Route path='/' element={<Layout size={size} />}>
              <Route index element={<Dashboard />} />
              {/* <Route path='bTest' element={<SiteDashboard />} />  */}
              <Route path='master1' element={<Master1 />} />
              <Route path='master2' element={<Master2 />} />
              <Route path='master3' element={<Master3 />} />
              <Route path='master4' element={<Master4 />} />
              <Route path='master6' element={<Master6 />} />
              <Route path='master7' element={<Master7 />} />
              <Route path='m_llm' element={<Master8 />} />
              <Route path='m_menu1' element={<Mmenu1 />} />
              <Route path='m_menu2' element={<Mmenu2 />} />
              <Route path='m_common1' element={<Mcommon1 />} />
              <Route path='m_common2' element={<Mcommon2 />} />
              <Route path='m_common3' element={<Mcommon3 />} />
              <Route path='m_common4' element={<Mcommon4 />} />
              <Route path='m_common5' element={<Mcommon5 />} />
              <Route path='m_common6' element={<Mcommon6 />} />
              <Route path='m_log' element={<LogReport />} />
              <Route path='h_info1' element={<Hinfo1 />} />
              <Route path='h_user1' element={<Huser1 />} />
              <Route path='h_cctv1' element={<Hcctv1 />} />
              <Route path='h_cctv2' element={<Hcctv2 />} />
              <Route path='h_sinfo1' element={<Hsinfo1 />} />
              <Route path='h_sinfo2' element={<Hsinfo2 />} />
              <Route path='h_common1' element={<Hcommon1 />} />
              <Route path='h_common2' element={<Hcommon2 />} />
              <Route path='h_common3' element={<Hcommon3 />} />
              <Route path='h_common4' element={<Hcommon4 />} />
              <Route path='h_visitor1' element={<Hvisitor1 />} />
              <Route path='h_visitor2' element={<Hvisitor2 />} />
              <Route path='h_log' element={<LogReport />} />
              <Route path='s_info1' element={<Sinfo1 />} />
              <Route path='s_worker1' element={<Sworker1 />} />
              <Route path='s_worker2' element={<Sworker2 />} />
              <Route path='s_worker4' element={<Sworker4 />} />
              <Route path='s_worker5' element={<Sworker5 />} />
              <Route path='s_worker6' element={<Sworker6 />} />
              <Route path='s_worker7' element={<Sworker7 />} />
              <Route path='s_worker8' element={<Sworker8 />} />
              <Route path='s_worker9' element={<Sworker9 />} />
              <Route path='s_worker10' element={<Sworker10 />} />
              <Route path='s_worker11' element={<Sworker11 />} />
              <Route path='s_attend1' element={<Sattend1 />} />
              <Route path='s_attend2' element={<Sattend2 />} />
              <Route path='s_attend3' element={<Sattend3 />} />
              <Route path='s_attend4' element={<Sattend4 />} />
              <Route path='s_attend5' element={<Sattend5 />} />
              <Route path='s_attend6' element={<Sattend6 />} />
              <Route path='s_attend7' element={<Sattend7 />} />
              <Route path='s_attend8' element={<Sattend8 />} />
              <Route path='s_attend9' element={<Sattend9 />} />
              <Route path='s_safe1' element={<Ssafe1 />} />
              <Route path='s_safe2' element={<Ssafe2 />} />
              {/* <Route path='s_safe3' element={<Ssafe3 />} /> */}
              <Route path='s_safe4' element={<Ssafe4 />} />
              <Route path='s_safe5' element={<Ssafe5 />} />
              <Route path='s_safe6' element={<Ssafe6 />} />
              <Route path='s_safe7' element={<Ssafe7 />} />
              <Route path='s_sensor1' element={<Ssensor1 />} />
              <Route path='s_sensor2' element={<Ssensor2 />} />
              <Route path='s_sensor3' element={<Ssensor3 />} />
              <Route path='s_sensor4' element={<Ssensor4 />} />
              <Route path='s_sensor5' element={<Ssensor5 />} />
              <Route path='s_sensor6' element={<Ssensor6 />} />
              <Route path='s_sensor7' element={<Ssensor7 />} />
              <Route path='s_sensor8' element={<Ssensor8 />} />
              <Route path='s_sensor9' element={<Ssensor9 />} />
              <Route path='s_sensor10' element={<Ssensor10 />} />
              <Route path='s_sensor11' element={<Ssensor11 />} />
              <Route path='s_user1' element={<Suser1 />} />
              <Route path='s_tunnel1' element={<Stunnel1 />} />
              <Route path='s_safeedu1' element={<Ssafeedu1 />} />
              <Route path='s_safeedu2' element={<Ssafeedu2 />} />
              <Route path='sm_setting1' element={<SMSetting1 mqtt={mqtt} />} />
              <Route path='sm_setting2' element={<SMSetting2 />} />
              <Route path='sm_setting3' element={<SMSetting3 />} />
              <Route path='sm_setting4' element={<SMSetting4 mqtt={mqtt} />} />
              <Route path='sm_setting5' element={<SMSetting5 />} />
              <Route path='sm_setting6' element={<SMSetting6 />} />
              <Route path='sm_setting7' element={<SMSetting7 />} />
              <Route path='sm_setting9' element={<SMSetting9 />} />
              <Route path='sm_setting10' element={<SMSetting10 />} />
              <Route path='sm_setting11' element={<SMSetting11 />} />
              <Route path='sm_setting12' element={<SMSetting12 />} />
              <Route path='sm_setting13' element={<SMSetting13 />} />
              <Route path='c_work1' element={<CWork1 />} />
              <Route path='c_work2' element={<CWork2 />} />
              <Route path='c_work3' element={<CWork3 />} />
              <Route path='c_work4' element={<CWork4 />} />
              <Route path='c_work5' element={<CWork5 />} />
              <Route path='c_work6' element={<CWork6 />} />
              <Route path='c_work7' element={<CWork7 />} />
              <Route path='c_company1' element={<CCompany1 />} />
              <Route path='c_company2' element={<CCompany2 />} />
              <Route path='c_company3' element={<CCompany3 />} />
              <Route path='c_user1' element={<CUser1 />} />
              <Route path='c_attend1' element={<Cattend1 />} />
              <Route path='c_attend2' element={<Cattend2 />} />
              <Route path='c_attend3' element={<Cattend3 />} />
              <Route path='c_attend4' element={<Cattend4 />} />
              <Route path='c_attend5' element={<Cattend5 />} />
              <Route path='c_board' element={<CBoard />} />
              <Route path='c_setting1' element={<CSetting1 mqtt={mqtt} />} />
              <Route path='c_setting2' element={<CSetting2 />} />
              <Route path='c_setting3' element={<CSetting3 mqtt={mqtt} />} />
              <Route path='c_setting4' element={<CSetting4 />} />
              <Route path='c_setting5' element={<CSetting5 />} />
              <Route path='c_setting6' element={<CSetting6 />} />
              <Route path='c_setting7' element={<CSetting7 />} />
              <Route path='c_setting11' element={<CSetting11 />} />
              <Route path='c_log' element={<LogReport />} />
              <Route path='s_cctv1' element={<Scctv1 />} />
              <Route path='s_log' element={<LogReport />} />
              <Route path='s_broadcast' element={<Sbroadcast1 />} />
              <Route path='/board' element={<SiteDashboard />} />
              <Route path='realtime_cctv' element={<RealtimeCCTV />} />
              <Route path='play_cctv' element={<PlayCCTV />} />
              <Route path='download_cctv' element={<DownloadCctv />} />
              <Route path='safeedu_video' element={<Video />} />
            </Route>
            {!window.FlutterWebView && <Route path='*' element={<NotFound />} />}
          </>
        ) : (
          !window.FlutterWebView && (
            <>
              <Route path='/' element={<Login />} />
              <Route path='/board' element={<SiteDashboard />} />
              <Route path='*' element={<Navigate to='/' replace />} />
            </>
          )
        )}
        <Route path='/service_report/:smIdx' element={<ServiceReportPage />} />
      </Routes>
      {openModal.status && login && openModal.type === 'alertModal' && <AlertModal openModal={openModal} setOpenModal={setOpenModal} alertType='emergency' />}
      {openAiModal.status && login && openAiModal.type === 'aiAlertModal' && <AlertModal openModal={openAiModal} setOpenModal={setOpenAiModal} alertType='ai' />}
      {appNotificationModal.isOpen && login && <AppNotificationModal openModal={appNotificationModal.isOpen} setOpenModal={setAppNotificationModal} data={appNotificationModal.data} />}
      <IosA2hsModal />
      {/* {openModal.status && login && openModal.type === 'noti' && location.pathname === '/' && (userInfo.gCd.toUpperCase() === 'MM' || userInfo.gCd.toUpperCase().slice(0, 1) === 'C') && (
        <NotiModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          onClickClose={() => setOpenModal({ status: false, type: 'noti' })}
          onClickConfirm={() => {
            setOpenModal({ status: false, type: 'noti' });
            window.localStorage.setItem('notiConfirmDate', `${new Date()}`);
          }}
        />
      )} */}
    </ThemeProvider>
  );
};

export default App;
